// eslint-disable-next-line
export const FEATURED_USERS_ADD = 'FEATURED_USERS_ADD';

export const FETCH_LIKED_USERS = 'FETCH_LIKED_USERS';
